export default __webpack_public_path__ + "static/Veteran-App-2e5e68960e0529e7afa27feb235a845e.webp";